export default class BookingRequirementsSummaryDto {
    position = '';
    positionDescription = ''
    skills = '';
    qualifications = '';
    uniformDescription = '';
}
